import React from 'react';
import Dropdown from "../Dropdown/Dropdown";

var ComboboxWrapper = function ComboboxWrapper(_ref) {
  var children = _ref.children,
      closeOnSelect = _ref.closeOnSelect,
      isOpen = _ref.isOpen,
      onToggle = _ref.onToggle;

  var handleToggle = function handleToggle(e) {
    var _e$target;

    if (closeOnSelect || (e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.getAttribute('role')) !== 'menuitem') {
      onToggle === null || onToggle === void 0 ? void 0 : onToggle();
    }
  };

  return /*#__PURE__*/React.createElement(Dropdown, {
    isOpen: isOpen,
    toggle: handleToggle
  }, children);
};

ComboboxWrapper.displayName = "ComboboxWrapper";
export default ComboboxWrapper;